export enum AnimationState {
  STOPED = "stoped",
  PLAYING = "playing",
  PAUSED = "paused",
}
